import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";

// Get Table Data
export const TurbidityTableDataAPI = createAsyncThunk("TurbidityTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_TTP_LocationID,
        M_WS_LocationID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID,
        handleWaterSupplyTurbidityExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterQualityTurbidity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_T_TTP_WaterQualityTurbidity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_TTP_LocationID=${M_TTP_LocationID ? M_TTP_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityTurbidity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleWaterSupplyTurbidityExport && handleWaterSupplyTurbidityExport()
                return result.data
            } else {
                return result
            }
        })
})

const TurbidityTableDataSlice = createSlice({
    name: "TurbidityTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(TurbidityTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(TurbidityTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(TurbidityTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const TurbidityTableDataReducer = TurbidityTableDataSlice.reducer

export const TurbidityTableExportDataAPI = createAsyncThunk("TurbidityTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_TTP_LocationID,
        M_WS_LocationID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterQualityTurbidity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_T_TTP_WaterQualityTurbidity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_TTP_LocationID=${M_TTP_LocationID ? M_TTP_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityTurbidity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const TurbidityTableExportDataSlice = createSlice({
    name: "TurbidityTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(TurbidityTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(TurbidityTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(TurbidityTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const TurbidityTableExportDataReducer = TurbidityTableExportDataSlice.reducer



export const TurbidityPostDataAPI = createAsyncThunk("PumpingStationPostData", async ({ data }) => {
    const {
        T_WS_WaterQualityTurbidityID,
        T_TTP_WaterQualityTurbidityID,
        Turibidity,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        T_Distri_WaterQualityTurbidityID,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterQualityTurbidityID", T_Distri_WaterQualityTurbidityID);
        formdata.append("Turibidity", Turibidity);
    } else if (DashProjectTypeId == '9') {
        formdata.append("T_TTP_WaterQualityTurbidityID", 8);
        formdata.append("Turbidity", Turibidity);
    } else {
        formdata.append("T_WS_WaterQualityTurbidityID", T_WS_WaterQualityTurbidityID);
        formdata.append("Turibidity", Turibidity);
    }

    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_Distri_WaterQualityTurbidity_Update`
    } else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_T_TTP_WaterQualityTurbidity_Update`
    } else {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_WS_WaterQualityTurbidity_Update`
    }

    fetch(url, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const TurbidityPostDataSlice = createSlice({
    name: "TurbidityPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(TurbidityPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(TurbidityPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(TurbidityPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const TurbidityPostDataReducer = TurbidityPostDataSlice.reducer

// -----------------Delete API ---------------

export const TurbidityDeleteAPI = createAsyncThunk("TurbidityDelete", async ({ data }) => {
    const {
        T_TTP_WaterQualityTurbidityID,
        T_WS_WaterQualityTurbidityID,
        T_Distri_WaterQualityTurbidityID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterQualityTurbidityID", T_Distri_WaterQualityTurbidityID);
    } else if (DashProjectTypeId == '9') {
        formdata.append("T_TTP_WaterQualityTurbidityID", T_TTP_WaterQualityTurbidityID);
    } else {
        formdata.append("T_WS_WaterQualityTurbidityID", T_WS_WaterQualityTurbidityID);
    }
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WaterQualityTurbidity_Delete`
    } else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/WEB_T_TTP_WaterQualityTurbidity_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_WaterQualityTurbidity_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const TurbidityDeleteSlice = createSlice({
    name: "TurbidityDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(TurbidityDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(TurbidityDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(TurbidityDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const TurbidityDeleteReducer = TurbidityDeleteSlice.reducer